// document.addEventListener("DOMContentLoaded", function () {
//     // details スライダーの初期化
//     if (document.querySelector("#splide-details")) {
//         new Splide("#splide-details", {
//             autoplay: true,
//             type: "loop",
//             arrows: true,
//             pagination: true,
//             pauseOnHover: false,
//             pauseOnFocus: false,
//             interval: 5000,
//             speed: 1000,
//             perPage: 2,
//             focus: 'center',
//             gap: 32,
//             perMove: 1,
//             padding: "5%",
//             breakpoints: {
//                 768: {
//                     perPage: 1,
//                     gap: 16,
//                     padding: "12%",
//                 },
//             },
//         }).mount();
//     }
// });

document.addEventListener("DOMContentLoaded", function () {
    // #splide-details に対して Splide スライダーを初期化
    if (document.querySelector("#splide-details")) {
        new Splide("#splide-details", {
            // スライダーが自動的に再生を開始する
            autoplay: true,
            // スライダーがループする設定
            type: "loop",
            // スライダーに前後の矢印ナビゲーションを表示
            arrows: false,
            // スライダーにページネーション（ドット）を表示
            pagination: false,            
            // マウスオーバー時にスライドが一時停止しない
            pauseOnHover: false,            
            // スライダーにフォーカスを当てても一時停止しない
            pauseOnFocus: false,            
            // スライドの自動切り替えの間隔を5秒に設定
            interval: 5000,            
            // スライド切り替え時のアニメーション速度を1秒（1000ms）に設定
            speed: 1000,            
            // 1ページあたりのスライド数を2に設定
            perPage: 4,            
            // スライドの表示位置を中央に設定
            focus: 'center',            
            // スライド間の隙間を32pxに設定
            gap: 32,            
            // スライド切り替え時に1つのスライドを移動する設定
            perMove: 1,            
            // スライダーにパディングを5%追加
            padding: "5%",            
            // ブレークポイントごとの設定
            breakpoints: {
                // 768px 以下の画面サイズの場合
                768: {
                    // 1ページあたりのスライド数を1に設定
                    perPage: 1,                    
                    // スライド間の隙間を16pxに設定
                    gap: 16,                    
                    // スライダーのパディングを12%に設定
                    padding: "12%",
                },
            },
        }).mount(); // スライダーのインスタンスをマウント（初期化）する
    }
});